import React from "react";

import PageTitle from "../elements/PageTitle";
import PricingTable from "../components/PricingTable";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * The Packages page, at /packages.
 *
 * This is the address that goes in adverts, so it is public, needs no account
 * and lists everything currently on sale.
 */
const Packages = () => {
  const { t } = useLanguage();

  return (
    <div className="page-content bg-white">
      <PageTitle activePage="Packages" parentTitle="Home" />

      <section className="content-inner-2">
        <div className="container">
          <div className="section-head style-1 text-center">
            <h5 className="sub-title">{t("Choose your access")}</h5>
            <h2 className="title">{t("Our Packages")}</h2>
            <p className="p-big mx-auto" style={{ maxWidth: 640 }}>
              {t("Every package opens a different part of the academy. Pick the one that matches how you train, and open any package to see exactly what it includes.")}
            </p>
          </div>
        </div>

        <PricingTable />
      </section>
    </div>
  );
};

export default Packages;
